import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { takeUntil, map, startWith } from 'rxjs/operators';

import { Event, EventPackage, EventService } from '../../../../services/event.service';

@Component({
  selector: 'app-event-table',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.25s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.25s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './event-table.component.html',
  styleUrls: ['./event-table.component.scss']
})
export class EventTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedEvent: Event;
  @Input() isDNR: boolean;
  @Output() eventEnded = new EventEmitter();

  filter = new FormControl('');

  eventPackages: EventPackage[];
  eventPackages$: Observable<EventPackage[]>;

  selectedEventPackage: EventPackage;

  unsubscribe: Subject<any> = new Subject();

  constructor(
    private eventService: EventService) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.eventService.getEventPackages(this.selectedEvent.eventId);
    this.eventService.eventPackages
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(eventPackages => {
        if (eventPackages) {
          this.eventPackages = eventPackages;
          this.eventPackages$ = this.filter.valueChanges.pipe(
            startWith(''),
            map(() => eventPackages)
          );
          var temp = eventPackages.find(x => x.permitAnnualOperatingPlanId === (this.selectedEventPackage || {} as EventPackage).permitAnnualOperatingPlanId);
          this.selectedEventPackage = temp;
        }
      })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  showDetail(row: EventPackage) {
    if (this.selectedEventPackage == row) {
      // Clicked the same row, deselect row
      this.selectedEventPackage = null;
    } else {
      // Clicked new row, select new row
      this.selectedEventPackage = row;
    }
  }

  endEvent() {
    this.eventService.endEvent(this.selectedEvent);
    this.eventEnded.emit();
  }

  endEventIsDisabled(): boolean {
    return this.hasOpenNotice() || this.hasEndDateInFuture();
  }

  hasOpenNotice(): boolean {
    return (this.eventPackages || []).some(x => x != null && x.allocationAmount != null && x.allocationAmount != 0);
  }

  hasEndDateInFuture(): boolean {
    const rightNow = new Date();
    return (this.eventPackages || []).some(e => e != null && e.allocationDate != null && new Date(e.allocationDate).valueOf() > rightNow.valueOf());
  }

  closeEventTooltip(): string {
    return [`${this.hasOpenNotice() ? "All notices must be closed to end the event" : ""}`,
            `${this.hasEndDateInFuture() ? "All allocation dates must be in the past to end the event." : ""}`]
            .filter(s => !!s)
            .join(" and ");
  }
}
